import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';
import { LanguageCodeFilterEnum } from '@/gql/client/graphql';

export function useLangCodeFilter() {
  const { lang } = useTranslation();
  const langCode = useMemo(() => lang.split('-')[0].toUpperCase(), [lang]);
  return langCode === LanguageCodeFilterEnum.En ? LanguageCodeFilterEnum.Default : langCode as LanguageCodeFilterEnum;
}
